import React from "react";
import { captureEvent } from "../../api/posthog";
import CtaBanner from "../CtaBanner";

const Joinvillage = () => {
  const handleDownload = () => {
    captureEvent("signup_started", { source: "landing_page_join_village" });
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(userAgent) || /Windows/i.test(userAgent)) {
      window.plausible("Play Store Click");
      window.location.href =
        "https://play.google.com/store/apps/details?id=com.social_spectrum.mobile";
    } else if (/iPad|iPhone|iPod|ios/.test(userAgent) && !window.MSStream) {
      window.plausible("App Store Click");
      window.location.href =
        "https://apps.apple.com/us/app/social-spectrum/id6473112455";
    } else {
      window.plausible("Play Store Click");
      window.open(
        "https://play.google.com/store/apps/details?id=com.social_spectrum.mobile",
        "_blank"
      );
    }
  };

  return (
    <CtaBanner
      light="Find your"
      bold="people."
      description="The spectrum is wide. So is your support. Join families who understand—in India and the US."
      onDownload={handleDownload}
      buttonLabel="Download Now →"
    />
  );
};

export default Joinvillage;
